var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isHead
        ? _c(
            "v-sheet",
            {
              staticClass:
                "\n      mx-auto\n      pa-2\n      flex-xl-grow-1\n      d-flex\n      flex-row\n      justify-space-between\n      align-center\n    ",
            },
            [
              _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
              _c("v-spacer"),
              _c(
                "div",
                { staticClass: "tools" },
                [
                  _vm.addBtn
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "text-capitalize ml-2 mr-2",
                          attrs: {
                            rounded: "",
                            small: "",
                            disabled: _vm.readonly,
                            color: "primary",
                            outlined: "",
                          },
                          on: { click: _vm.toAddGroup },
                        },
                        [
                          _c("span", { staticClass: "material-icons-round" }, [
                            _vm._v("add"),
                          ]),
                          _vm._v(" " + _vm._s(_vm.$t(_vm.addBtn)) + " "),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("v-data-table", {
        staticClass: "rounded-lg",
        class: "elevation-" + _vm.elevation,
        staticStyle: { border: "1px solid #e1e1e1", overflow: "hidden" },
        attrs: {
          headers: _vm.headers,
          items: _vm.items,
          page: _vm.page,
          "item-key": "uuid",
          "fixed-header": "",
          "hide-default-header": !_vm.show,
          height: _vm.tableHeight,
          loading: _vm.loading || _vm.Loading || _vm.isLoading,
          "loading-text": "Loading... Please wait",
          "hide-default-footer": "",
          "items-per-page": _vm.showFooter ? _vm.itemsPerPage : 1000,
          elevation: 0,
          "footer-props": {
            "items-per-page-options": [10, 20, 50],
            "items-per-page-text": _vm.$t(
              "label_essweb_list_components_pagenations_perpageLabel"
            ),
          },
        },
        on: {
          "update:page": function ($event) {
            _vm.page = $event
          },
          "page-count": function ($event) {
            _vm.$tableSetting.pageCount = $event
          },
        },
        scopedSlots: _vm._u(
          [
            {
              key: "no-data",
              fn: function () {
                return [_vm.show ? _c("noContent") : _vm._e()]
              },
              proxy: true,
            },
            _vm._l(_vm.headers, function (it) {
              return {
                key: "header." + it.value,
                fn: function (ref) {
                  var header = ref.header
                  return [
                    _vm._t(
                      "header." + it.value,
                      function () {
                        return [
                          _c(
                            "div",
                            {
                              key: it.value,
                              staticClass: "text-body-2 table-header-color",
                              style: {
                                minWidth: it.width
                                  ? it.width + "px  !important"
                                  : "100px !important",
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.$t(it.text)) + " ")]
                          ),
                        ]
                      },
                      { header: header }
                    ),
                  ]
                },
              }
            }),
            _vm.tableTitle != ""
              ? {
                  key: "top",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        {
                          staticClass:
                            "\n          mx-auto\n          pa-2\n          d-flex\n          flex-row\n          justify-space-between\n          align-center\n        ",
                          style: {
                            borderBottom: _vm.show
                              ? "1px solid #e1e1e1"
                              : "none",
                          },
                          attrs: { height: "50" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "subtitle-1 text--secondary text--lighten--3",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$getCommonLangValue(_vm.tableTitle)
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c("v-spacer"),
                          _vm.type != "shift" &&
                          _vm.type != "staff" &&
                          _vm.type != "manage"
                            ? _c(
                                "div",
                                { staticClass: "tools" },
                                [
                                  _vm.type != "site" && !_vm.readonly
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            icon: "",
                                            disabled: _vm.readonly,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.toEditGroup()
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "material-icons-round",
                                            },
                                            [_vm._v("edit")]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  !_vm.readonly
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            icon: "",
                                            disabled: _vm.readonly,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.toDeleteGroup()
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "material-icons-round",
                                            },
                                            [_vm._v("delete")]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { icon: "" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          _vm.show = !_vm.show
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "material-icons-round" },
                                        [_vm._v("unfold_less")]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
            _vm.type == "face"
              ? {
                  key: "item.face_name",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        _vm._s(
                          _vm.$getCommonLangValue(item.criteria_facial_name)
                        )
                      ),
                    ]
                  },
                }
              : null,
            _vm.type == "face"
              ? {
                  key: "item.face_simi",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        " " + _vm._s(item.facial_recognition_similarity) + " "
                      ),
                    ]
                  },
                }
              : null,
            _vm.type == "face"
              ? {
                  key: "item.face_status",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c(
                        "v-chip",
                        {
                          attrs: {
                            small: "",
                            color:
                              Number(item.status) === 1
                                ? "green"
                                : "blue-grey lighten-2",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              Number(item.status) === 1
                                ? _vm.$t("label_essweb_system_status_onLabel")
                                : _vm.$t("label_essweb_system_status_offLabel")
                            ) + " "
                          ),
                        ]
                      ),
                    ]
                  },
                }
              : null,
            _vm.type == "gps"
              ? {
                  key: "item.gps_name",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        _vm._s(
                          _vm.$getCommonLangValue(item.criteria_gps_name)
                        ) + " "
                      ),
                    ]
                  },
                }
              : null,
            _vm.type == "gps"
              ? {
                  key: "item.gps_dis",
                  fn: function (ref) {
                    var item = ref.item
                    return [_vm._v(_vm._s(item.within_distance_meter) + " ")]
                  },
                }
              : null,
            _vm.type == "gps"
              ? {
                  key: "item.gps_status",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c(
                        "v-chip",
                        {
                          attrs: {
                            small: "",
                            color:
                              Number(item.status) === 1
                                ? "green"
                                : "blue-grey lighten-2",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              Number(item.status) === 1
                                ? _vm.$t("label_essweb_system_status_onLabel")
                                : _vm.$t("label_essweb_system_status_offLabel")
                            ) + " "
                          ),
                        ]
                      ),
                    ]
                  },
                }
              : null,
            _vm.type == "wifi"
              ? {
                  key: "item.wifi_name",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        _vm._s(
                          _vm.$getCommonLangValue(item.criteria_wifi_name)
                        ) + " "
                      ),
                    ]
                  },
                }
              : null,
            _vm.type == "wifi"
              ? {
                  key: "item.wifi_site",
                  fn: function (ref) {
                    var item = ref.item
                    return [_vm._v(_vm._s(item.site_uuid) + " ")]
                  },
                }
              : null,
            _vm.type == "wifi"
              ? {
                  key: "item.wifi_ip",
                  fn: function (ref) {
                    var item = ref.item
                    return [_vm._v(_vm._s(item.ssid) + " ")]
                  },
                }
              : null,
            _vm.type == "wifi"
              ? {
                  key: "item.wifi_status",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c(
                        "v-chip",
                        {
                          attrs: {
                            small: "",
                            color:
                              Number(item.status) === 1
                                ? "green"
                                : "blue-grey lighten-2",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              Number(item.status) === 1
                                ? _vm.$t("label_essweb_system_status_onLabel")
                                : _vm.$t("label_essweb_system_status_offLabel")
                            ) + " "
                          ),
                        ]
                      ),
                    ]
                  },
                }
              : null,
            _vm.type == "bluetooth"
              ? {
                  key: "item.bluetooth_name",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$getCommonLangValue(
                              item.criteria_bluetooth_name
                            )
                          ) +
                          " "
                      ),
                    ]
                  },
                }
              : null,
            _vm.type == "bluetooth"
              ? {
                  key: "item.bluetooth_site",
                  fn: function (ref) {
                    var item = ref.item
                    return [_vm._v(" " + _vm._s(item.site_uuid) + " ")]
                  },
                }
              : null,
            _vm.type == "bluetooth"
              ? {
                  key: "item.bluetooth_ip",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(" " + _vm._s(item.bluetooth_device_uuid) + " "),
                    ]
                  },
                }
              : null,
            _vm.type == "bluetooth"
              ? {
                  key: "item.bluetooth_status",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c(
                        "v-chip",
                        {
                          attrs: {
                            small: "",
                            color:
                              Number(item.status) === 1
                                ? "green"
                                : "blue-grey lighten-2",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              Number(item.status) === 1
                                ? _vm.$t("label_essweb_system_status_onLabel")
                                : _vm.$t("label_essweb_system_status_offLabel")
                            )
                          ),
                        ]
                      ),
                    ]
                  },
                }
              : null,
            _vm.type == "staff"
              ? {
                  key: "item.staff_id",
                  fn: function (ref) {
                    var item = ref.item
                    return [_vm._v(" " + _vm._s(item.staff_code) + " ")]
                  },
                }
              : null,
            _vm.type == "manage"
              ? {
                  key: "item.staff_name",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$getCommonLangValue(item.preferred_name)) +
                          " "
                      ),
                      _c(
                        "span",
                        { staticClass: "text--secondary text-caption-xs" },
                        [_vm._v(" " + _vm._s(item.staff_code))]
                      ),
                    ]
                  },
                }
              : null,
            _vm.type == "manage"
              ? {
                  key: "item.staffid",
                  fn: function (ref) {
                    var item = ref.item
                    return [_vm._v(" " + _vm._s(item.staff_id) + " ")]
                  },
                }
              : null,
            _vm.type == "shift"
              ? {
                  key: "item.shift_name",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$getCommonLangValue(item.shift_name)) +
                          " "
                      ),
                    ]
                  },
                }
              : null,
            _vm.type == "site"
              ? {
                  key: "item.name",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            item.criteria
                              ? item.criteriaType.punch_code == "FACE"
                                ? _vm.$getCommonLangValue(
                                    item.criteria.criteria_facial_name
                                  )
                                : item.criteriaType.punch_code == "WIFI"
                                ? _vm.$getCommonLangValue(
                                    item.criteria.criteria_wifi_name
                                  )
                                : item.criteriaType.punch_code == "GPS"
                                ? _vm.$getCommonLangValue(
                                    item.criteria.criteria_gps_name
                                  )
                                : item.criteriaType.punch_code == "BLUETOOTH"
                                ? _vm.$getCommonLangValue(
                                    item.criteria.criteria_bluetooth_name
                                  )
                                : ""
                              : "Null"
                          ) +
                          " "
                      ),
                    ]
                  },
                }
              : null,
            _vm.type == "site"
              ? {
                  key: "item.type",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$getCommonLangValue(
                              item.criteriaType.criteria_type_name
                            )
                          ) +
                          " "
                      ),
                    ]
                  },
                }
              : null,
            {
              key: "item.time",
              fn: function (ref) {
                var item = ref.item
                return [
                  _c("div", { staticClass: "text--primary" }, [
                    _vm._v(_vm._s(item.time.time)),
                  ]),
                ]
              },
            },
            {
              key: "item.status",
              fn: function (ref) {
                var item = ref.item
                return [
                  _vm.type == "other1" || _vm.type == "other2"
                    ? [_vm._v(" " + _vm._s(_vm.$t(item.status)) + " ")]
                    : _vm._e(),
                ]
              },
            },
            _vm.type == "shift"
              ? {
                  key: "item.shifttime",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        _vm._s(
                          _vm.$timeMachine(item.start_utc_time) +
                            "--" +
                            _vm.$timeMachine(item.end_utc_time)
                        )
                      ),
                    ]
                  },
                }
              : null,
            {
              key: "footer",
              fn: function (ref) {
                var props = ref.props
                return [
                  _vm.showFooter && _vm.items.length > 10 && _vm.show
                    ? _c("Pagenations", {
                        attrs: {
                          options: props,
                          filterpage: _vm.page,
                          "local-loading": _vm.Loading,
                          filterItemsPerPage: _vm.itemsPerPage,
                          items:
                            _vm.totalCount !== undefined
                              ? _vm.totalCount
                              : _vm.items,
                        },
                        on: { change: _vm.onChange },
                      })
                    : _vm._e(),
                  _vm.show && !_vm.readonly
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "\n          mx-auto\n          pa-2\n          d-flex\n          flex-row\n          justify-space-between\n          align-center\n        ",
                          style: {
                            borderTop: !_vm.show ? "" : "1px solid #e1e1e1",
                          },
                          attrs: { height: "50" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "tools" },
                            [
                              _vm.newBtn != "" && !_vm.readonly
                                ? _c(
                                    "v-btn",
                                    {
                                      staticClass: "text-capitalize",
                                      attrs: {
                                        text: "",
                                        color: "primary",
                                        disabled: _vm.readonly,
                                      },
                                      on: { click: _vm.toNew },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "label_essweb_special_tale_addBtnLabel"
                                            ) +
                                              (_vm.isNeedSpace ? " " : "") +
                                              _vm.$t(_vm.newBtn)
                                          ) +
                                          " "
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "material-icons-round" },
                                        [_vm._v("add")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c("v-spacer"),
                          _c("div"),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              },
            },
            {
              key: "item.action",
              fn: function (ref) {
                var item = ref.item
                return [
                  _vm.type == "staff" ||
                  _vm.type == "shift" ||
                  _vm.type == "manage" ||
                  _vm.type == "site"
                    ? [
                        !_vm.readonly
                          ? _c(
                              "v-btn",
                              {
                                attrs: { icon: "", disabled: _vm.readonly },
                                on: {
                                  click: function ($event) {
                                    return _vm.toDelete(item)
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "material-icons-round" },
                                  [_vm._v("delete")]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    : [
                        _c(
                          "v-btn",
                          {
                            attrs: { icon: "" },
                            on: {
                              click: function ($event) {
                                return _vm.toEdit(item)
                              },
                            },
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "material-icons-round" },
                              [_vm._v("edit")]
                            ),
                          ]
                        ),
                        _c(
                          "v-btn",
                          {
                            attrs: { icon: "" },
                            on: {
                              click: function ($event) {
                                return _vm.toDelete(item)
                              },
                            },
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "material-icons-round" },
                              [_vm._v("delete")]
                            ),
                          ]
                        ),
                      ],
                ]
              },
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }